import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";

import Product_1 from "../Assets/Products/Product_1.jpeg";
import Product_2 from "../Assets/Products/Product_2.png";
import Product_3 from "../Assets/Products/Product_3.png";
import Product_5 from "../Assets/Products/Product_5.png";
import limited1 from "../Assets/Products/Limited_11.png";
import limited2 from "../Assets/Products/Limited_22.png";
import limited3 from "../Assets/Products/Limited_33.jpeg";

const CompanySwipe: React.FC = () => {
  const productImages: string[] = [
    Product_1,
    Product_2,
    Product_3,
    Product_5,
    limited1,
    limited2,
    limited3,
  ];

  return (
    <div className="companyPartners">
      <h2 style={{ textAlign: "center", paddingTop: "20px", paddingBottom: "20px" ,color:'#5e626b'}}>
        BRAND SCROLLING LIST
      </h2>
      <Swiper
        slidesPerView={5}
        spaceBetween={20}
        loop={true}
        speed={12000}
        autoplay={{
          delay: 0,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        }}
        freeMode={true}
        modules={[Autoplay]}
      >
        {productImages.map((product, index) => (
          <SwiperSlide key={index}>
            <div className="aboutBrands" style={{ textAlign: "center" }}>
              <img
                src={product}
                alt={`brand-${index}`}
                style={{ maxHeight: "80px", width: "auto", objectFit: "contain" }}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default CompanySwipe;
